var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton";
import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import Menu from "./Menu";
import MenuButton from "./MenuButton";
import landingLogo from "../../img/modinet-landing-logo.png";
import logo from "../../img/modinet-logo.png";
import { WebSocketMessage } from "../../serverConnection";
var adminLinks = function (role) { return (React.createElement("div", null,
    React.createElement("li", null,
        React.createElement(Link, { to: "/orders" }, "Orders")),
    React.createElement("li", null,
        React.createElement(Link, { to: "/users" }, "Users")),
    React.createElement("li", null,
        React.createElement(Link, { to: "/videos" }, "Videos")),
    React.createElement("li", null,
        React.createElement(Link, { to: "/devices" }, "Devices")),
    React.createElement("li", null,
        React.createElement(Link, { to: "/products" }, "Products")),
    React.createElement("li", null,
        React.createElement(Link, { to: "/enterprises" }, "Enterprises")))); };
var agentLinks = (React.createElement("div", null,
    React.createElement("li", null,
        React.createElement(Link, { to: "/orders" }, "Orders")),
    React.createElement("li", null,
        React.createElement(Link, { to: "/users" }, "Users")),
    React.createElement("li", null,
        React.createElement(Link, { to: "/videos" }, "Videos")),
    React.createElement("li", null,
        React.createElement(Link, { to: "/devices" }, "Devices")),
    React.createElement("li", null,
        React.createElement(Link, { to: "/products" }, "Products")),
    React.createElement("li", null,
        React.createElement(Link, { to: "/enterprises" }, "Enterprises"))));
var Navbar = /** @class */ (function (_super) {
    __extends(Navbar, _super);
    function Navbar(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.handleMouseDown = function (e) {
            _this.toggleMenu();
            e.stopPropagation();
        };
        _this.toggleMenu = function () {
            _this.setState({
                visible: !_this.state.visible,
            });
        };
        _this.onLogoutClick = function (e) {
            var _a, _b;
            e.preventDefault();
            localStorage.removeItem("user");
            _this.props.send(WebSocketMessage("login", "delete", { id: (_a = _this.props.user) === null || _a === void 0 ? void 0 : _a.id }, (_b = _this.props.user) === null || _b === void 0 ? void 0 : _b.token));
            _this.props.dispatch({ action: "logout" });
            _this.props.history.push("/login");
        };
        _this.state = {
            visible: false,
        };
        return _this;
    }
    Navbar.prototype.render = function () {
        var user = this.props.user;
        var userLinks = (React.createElement("div", null,
            React.createElement("li", null,
                React.createElement(Link, { to: "/orders" }, "My Order")),
            React.createElement("li", null,
                React.createElement(Link, { to: "/videos" }, "Videos"))));
        var authNav = user && (React.createElement("nav", { className: "nav-auth" },
            React.createElement("div", { className: "nav-wrapper" },
                React.createElement(Link, { to: "/", className: "brand-logo center" },
                    React.createElement("img", { src: logo, id: "logo", alt: "modinet - the future of digital signage" })),
                React.createElement("div", null,
                    React.createElement(MenuButton, { handleMouseDown: this.handleMouseDown }),
                    React.createElement(Menu, { handleMouseDown: this.handleMouseDown, menuVisibility: this.state.visible, role: user.role }),
                    React.createElement("ul", { className: "left hide-on-med-and-down" }, user.role === "customer"
                        ? userLinks
                        : user.role === "agent"
                            ? agentLinks
                            : adminLinks(user.role)),
                    React.createElement("ul", { className: "right" },
                        React.createElement("li", { className: "hide-on-med-and-down" },
                            React.createElement(Link, { to: "/profile/" + user.id }, "Own profile")),
                        React.createElement("li", null, user.role === "customer" ? (React.createElement(Link, { to: "/user/docs" }, "Help")) : user.role === "agent" ? (React.createElement(Link, { to: "/agent/docs" }, "Help")) : null),
                        React.createElement("li", null,
                            React.createElement(IconButton, { onClick: this.onLogoutClick },
                                React.createElement(Icon, null, "power_settings_new"))))))));
        var guestNav = !user && (React.createElement("nav", { className: "transparent z-depth-0" },
            React.createElement("div", { className: "nav-wrapper" },
                React.createElement(Link, { to: "/", className: "brand-landing left" },
                    React.createElement("img", { src: landingLogo, id: "landing-logo", alt: "modinet - the future of digital signage" })),
                React.createElement("div", { className: "headline-landing hide-on-med-and-down" },
                    React.createElement("h1", null,
                        "MODINET",
                        React.createElement("br", null),
                        "DIGITAL SIGNAGE")),
                React.createElement("div", null,
                    React.createElement("ul", { className: "right hide-on-med-and-down" })))));
        return React.createElement("div", null, user ? authNav : guestNav);
    };
    return Navbar;
}(Component));
export default withRouter(Navbar);



//////////////////
// WEBPACK FOOTER
// ./src/components/layout/Navbar.tsx
// module id = 1009
// module chunks = 0